import React from "react";
import {
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Box,
} from "@mui/material";
import { getPointerEventsStyles, getReadOnlyStyles } from "../../lib/styles";

export function RadioBooleanInput({
  fieldConfig,
  controllerField,
  fieldState,
}) {
  const { readOnly, optionLabels = {} } = fieldConfig;
  const { name, value, onChange, ...rest } = controllerField;

  const { trueLabel = "Yes", falseLabel = "No", nullLabel } = optionLabels;

  const handleChange = (e) => {
    const v = e.target.value;
    if (v === "true") return onChange(true);
    if (v === "false") return onChange(false);
    return onChange(null);
  };

  return (
    <FormControl component="fieldset" error={!!fieldState.error} fullWidth>
      <Box sx={{ ...getReadOnlyStyles(readOnly), ml: 1 }}>
        <RadioGroup
          row
          name={name}
          value={value === null ? "null" : value.toString()}
          onChange={handleChange}
          sx={getPointerEventsStyles(readOnly)}
        >
          <FormControlLabel
            value="false"
            control={<Radio {...rest} size="small" />}
            label={falseLabel}
            disabled={readOnly}
          />
          <FormControlLabel
            value="true"
            control={<Radio {...rest} size="small" />}
            label={trueLabel}
            disabled={readOnly}
          />
          {nullLabel !== undefined && (
            <FormControlLabel
              value="null"
              control={<Radio {...rest} size="small" />}
              label={nullLabel}
              disabled={readOnly}
            />
          )}
        </RadioGroup>
      </Box>
      {!!fieldState.error && (
        <FormHelperText>{fieldState.error.message}</FormHelperText>
      )}
    </FormControl>
  );
}
